import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { connect } from 'react-redux';
import PriceForm from './PriceForm';
import { SUCCESS } from '../../actionTypes';
import s from './CartForm.module.scss';

const PriceDialogForm = props => {
  const { t, requestMessage, goodId, goodName } = props;
  const [open, setOpen] = useState(false);
  const [stateBtn, setStateBtn] = useState({
    disabled: false,
    title: t['Запросить цену']
  });
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (requestMessage.state === SUCCESS && requestMessage.data.success) {
      if (requestMessage.data.data.goodId === goodId) {
        enqueueSnackbar(t['Отправлен'], { variant: 'success' });
        setStateBtn({
          disabled: true,
          title: t['Отправлен']
        });
      }
      setOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestMessage]);

  const handleClickOpen = () => {
    if (stateBtn.disabled) return;
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <div variant="outlined" onClick={handleClickOpen}>
        {props.buttonPriceDialogForm(stateBtn)}
      </div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle className={s.title} disableTypography>
          {t['Заполните форму и наши менеджеры свяжутся с Вами']}
        </DialogTitle>
        <DialogContent>
          <PriceForm goodId={goodId} goodName={goodName} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

const mapStateToProps = state => ({
  t: state.translation,
  requestMessage: state.priceRequestMessage
});

export default connect(mapStateToProps)(PriceDialogForm);
